registerComponent("sections/numeros", function (component) {
/**
 * A entrada na rolagem (ADR 0051): os quatro números entram escalonados quando
 * a faixa chega na tela — numa linha no desktop, um a um abaixo do degrau. O
 * mesmo padrão do `sections/quem-somos`, sem coreografia nova.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');

});
